import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=60ec46f4&scoped=true&"
import script from "./Employment.vue?vue&type=script&lang=js&"
export * from "./Employment.vue?vue&type=script&lang=js&"
import style0 from "./Employment.vue?vue&type=style&index=0&id=60ec46f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec46f4",
  null
  
)

export default component.exports